export const toTitleCase = (str: string): string =>
  str?.replace(
    /[a-zA-Z0-9_åäöÅÄÖ]\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
